
import styles from './Panel.module.scss'
import {ComponentPropsWithoutRef, ElementType} from "react";

export default <T extends ElementType = 'a'>(
  {
    as,
    message,
    className,
    children,
    fixed,
    ...props
  }:
    ComponentPropsWithoutRef<T> & {
    as?: T
    message?: string
    className?: string
    fixed?: boolean
  }) => {

  const Component = as || fixed ? 'div' : 'a'
  return <Component className={`${styles.panel} ${fixed ? styles.fixed : ''} ${className ? className : ''}`} {...props}>{children}</Component>
}
